import React, { useState } from "react";
import CreateServiceCenter from "./CreateServiceCenter";
import AllServiceCenters from "./AllServiceCenters";




const ServiceCenters = () => {
    const [activeTab, setActiveTab] = useState("AllServiceCenters");

    const tabs = [
        "AllServiceCenters",
        "CreateServiceCenter",
       
    ];

    return (
        <div style={styles.wrapper}>
            {/* ---------- TABS ---------- */}
            <div style={styles.tabs}>
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        style={{
                            ...styles.tabBtn,
                            borderBottom:
                                activeTab === tab ? "2px solid #005487" : "none",
                            color: activeTab === tab ? "#005487" : "#333",
                        }}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {/* ---------- TAB CONTENT ---------- */}
            {activeTab === "AllServiceCenters" && <AllServiceCenters />}
            {activeTab === "CreateServiceCenter" && <CreateServiceCenter />}
            
        </div>
    );
};

export default ServiceCenters;

/* ---------- STYLES ---------- */
const styles = {
    wrapper: {
        background: "#fff",
        padding: "15px",
        borderRadius: "6px",
    },

    tabs: {
        display: "flex",
        borderBottom: "1px solid #ddd",
        marginBottom: "15px",
        overflowX: "auto",
    },

    tabBtn: {
        background: "none",
        border: "none",
        padding: "10px 16px",
        cursor: "pointer",
        fontWeight: 500,
        whiteSpace: "nowrap",
    },
};
